import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'mK4GCu',
    defaultMessage: 'Account Information',
    description: 'Section title for the read-only account information summary',
  },
});
